import { PatronageAnswer } from '../../../typings/AdditionalInformation'
import { Origin } from '../../../graphql'

const answersMapping = {
  eversports: { value: PatronageAnswer.PATRONAGE_ANSWER_EVERSPORTS, label: 'patronage-answer-eversports' },
  members: { value: PatronageAnswer.PATRONAGE_ANSWER_VENUE_MEMBERS, label: 'patronage-answer-venue-members' },
  channels: { value: PatronageAnswer.PATRONAGE_ANSWER_VENUE_CHANNELS, label: 'patronage-answer-venue-channels' },
  customer: { value: PatronageAnswer.PATRONAGE_ANSWER_VENUE_CUSTOMER, label: 'patronage-answer-venue-customer' },
}

export interface PatronageAnswerMapping {
  value: PatronageAnswer
  label: string
}

const getOrderedPatronageAnswers = (origin: Origin): Array<PatronageAnswerMapping> => {
  switch (origin) {
    case Origin.ORIGIN_WIDGET:
    case Origin.ORIGIN_PROVIDER_API:
      return [answersMapping.members, answersMapping.channels, answersMapping.customer, answersMapping.eversports]
    case Origin.ORIGIN_MARKETPLACE:
    case Origin.ORIGIN_ANDROID:
    case Origin.ORIGIN_IOS:
    default:
      return [answersMapping.eversports, answersMapping.members, answersMapping.channels, answersMapping.customer]
  }
}

export const getRandomizedPatronageAnswer = (): Array<PatronageAnswerMapping> =>
  [answersMapping.eversports, answersMapping.members, answersMapping.channels, answersMapping.customer]
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value)

export default getOrderedPatronageAnswers
